import React,{useState} from 'react';
import './App.css';
import {  Box , AspectRatio, Grid, GridItem, Center  ,useColorModeValue,Image, Flex,Link } from '@chakra-ui/react';
import { ColorModeSwitcher } from './ColorModeSwitcher';
import Carousel from 'react-gallery-carousel';
import 'react-gallery-carousel/dist/index.css';
import Buttonglass from "./buttonglass"
import { FaTwitter,FaGithub,FaInstagram } from 'react-icons/fa';

import { HiShare } from "react-icons/hi";

import { motion ,AnimatePresence } from "framer-motion"


import {useWindowWidth} from '@react-hook/window-size'




const images =[
  {src:"./img/website.png"},{src:"./img/website32.png"},{src:"./img/website33.png"},
  {src:"./img/website2.png"},{src:"./img/website31.png"},{src:"./img/website34.png"},
  {src:"./img/website3.png"},{src:"./img/website30.png"},{src:"./img/website35.png"},
  {src:"./img/website4.png"},{src:"./img/website29.png"},{src:"./img/website36.png"},
  {src:"./img/website5.png"},{src:"./img/website28.png"},{src:"./img/website37.png"},
  {src:"./img/website6.png"},{src:"./img/website27.png"},{src:"./img/website38.png"},
  {src:"./img/website7.png"},{src:"./img/website26.png"},{src:"./img/website39.png"},
  {src:"./img/website8.png"},{src:"./img/website25.png"},{src:"./img/website40.png"},
  {src:"./img/website9.png"},{src:"./img/website24.png"},{src:"./img/website41.png"},
  {src:"./img/website10.png"},{src:"./img/website23.png"},{src:"./img/website42.png"},
  {src:"./img/website11.png"},{src:"./img/website22.png"},{src:"./img/website43.png"},
  {src:"./img/website12.png"},{src:"./img/website21.png"},{src:"./img/website44.png"},
  {src:"./img/website13.png"},{src:"./img/website20.png"},{src:"./img/website45.png"},
  {src:"./img/website14.png"},{src:"./img/website19.png"},{src:"./img/website46.png"},
  {src:"./img/website15.png"},{src:"./img/website18.png"},{src:"./img/website47.png"},
  {src:"./img/website16.png"},{src:"./img/website17.png"},{src:"./img/website48.png"},
  {src:"./img/website49.png"},{src:"./img/website50.png"},
]


const variants1 = {
  visible: { opacity: 1 ,y:"1rem" ,x:"0" ,transition: { duration: 0.6 }},
  hidden: { opacity: 0 ,y: "0"  ,x:"0"},
}


const  hidden= { opacity: 0 ,y: "-4.5rem" ,x:"1.8rem" ,transition: { duration: 0.6 } }





function App() {


const onlyw =useWindowWidth()



const [showsocial, setShowsocial] = useState(false)



  const bodybg = useColorModeValue("lightbg.png", "darkbg.png");
  const navmod = useColorModeValue("navlight", "navdark");
 


  return (
    <>
    <Box bgImg={`${bodybg}`} className="bg" position="fixed" top="0" h="100vh" w="100vw" zIndex="-100"></Box>
    <Flex
  h={{base:"7rem" , XL:"10rem"}}
  w="100%"
 
justify="space-evenly"

align="center"

className={`${navmod}`}


>

<Box    >   <Buttonglass color="#f79e02"  ><ColorModeSwitcher/></Buttonglass> </Box>









<Box   display={{base:"none", L:"inherit"}}   >  <Buttonglass color="#f79e02"  ><Link target="_blank" href="https://www.instagram.com/globalgroup16?r=nametag"><FaInstagram  style={{fontSize:"2.8rem" }} /></Link></Buttonglass> </Box>
<Box    > <Center >   <Image h={{base:"5rem", XL:"8rem"}}  minW={{base:"5rem", XL:"8rem"}} src="los.png"  /></Center></Box>
<Box   display={{base:"none", L:"inherit"}}   >   <Buttonglass color="#f79e02"  ><Link target="_blank" href="https://github.com/angelhtml"><FaGithub  style={{fontSize:"2.8rem" }} /></Link></Buttonglass> </Box>

<Box   display={{base:"none", L:"inherit"}}    >  <Buttonglass color="#f79e02"  ><Link target="_blank" href="https://twitter.com/globalgroup16?s=09" ><FaTwitter  style={{fontSize:"2.8rem" }} /></Link></Buttonglass> </Box>




<Box  display={{base:"inherit", L:"none"}}    >   <Buttonglass color="#f79e02"    ><a onClick={()=>setShowsocial(!showsocial)}><HiShare style={{fontSize:"2.8rem" ,cursor:"pointer"}} /></a></Buttonglass> </Box>






</Flex>


{showsocial &&onlyw <=768   &&

<motion.div   exit={hidden }   initial="hidden" animate="visible" variants={variants1}  >  
<Flex  position="absolute"  w="100%" justify="space-evenly" align="center" >
 <Buttonglass color="#f79e02"  ><Link target="_blank" href="https://www.instagram.com/globalgroup16?r=nametag" ><FaInstagram  style={{fontSize:"2.8rem" }} /></Link> </Buttonglass> 
 <Buttonglass color="#f79e02"  ><Link target="_blank" href="https://github.com/angelhtml" ><FaGithub  style={{fontSize:"2.8rem" }} /></Link></Buttonglass> 
 <Buttonglass color="#f79e02"  ><Link target="_blank" href="https://twitter.com/globalgroup16?s=09" ><FaTwitter  style={{fontSize:"2.8rem" }} /></Link></Buttonglass> 
 </Flex>
</motion.div>

}







<Center marginTop="7rem">
    <AspectRatio  width={{base:"100%" ,XXL:"80%" ,XXXL:"60%"}} ratio={5 / 3}>
      <Box className="sliderholder" >
<Carousel   images={images} objectFit="fill" />
</Box>
</AspectRatio>
</Center>

 </>
  );
}

export default App;
